import React from "react";
import styles from "./FullScreenWrapper.module.css";
interface Props {
  children: React.ReactNode;
}
export const FullScreenWrapper = ({ children }: Props) => {
  return <div className={styles.container}>{children}</div>;
};
